import React, {useState,useEffect} from "react";
import "./css/Hero.css"
import "./css/Fonts.css"

function calculateTimeLeft() {
    const difference = +new Date("Mar 6, 2021 08:00:00") - +new Date();
    let timeLeft = {};
  
    if (difference > 0) {
      timeLeft = {
        days: Math.floor(difference / (1000 * 60 * 60 * 24)),
        hours: Math.floor((difference / (1000 * 60 * 60)) % 24),
        minutes: Math.floor((difference / 1000 / 60) % 60),
        seconds: Math.floor((difference / 1000) % 60)
      };
    }else{
        timeLeft = {
            days: 0,
            hours: 0,
            minutes: 0,
            seconds: 0
        }
    }
  
    return timeLeft;
}

export default function Hero(){

    const [timeLeft, setTimeLeft] = useState(calculateTimeLeft());

    useEffect(() => {
        const id = setTimeout(() => {
        setTimeLeft(calculateTimeLeft());
        }, 1000);

        return () => {
        clearTimeout(id);
        };
    });

    return (
        <section id="hero" className="section d-flex justify-content-center mb-lg-5">
            <div className="container position-relative" data-aos="zoom-in" data-aos-delay="100">
                <div className="row main-title">
                    <div className="col-12">
                        <div className="row">
                            <div className="col-lg-12">
                                <div className="hero-content">
                                <div className="row">
                                    <div className="col-12">
                                        <h1 className="main-text text-center">Sani &amp; Rijal</h1>
                                    </div>
                                </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="counter ticktock">
                    <div className="row">
                        <div className="col-12">
                            <div className="row">
                                <div className="col-12 mb-3">
                                <h1 className="counter-text text-center">We Are Getting Married!</h1>
                                </div>
                            </div>
                            <div className="row counter-clock">
                                <div className="col-lg-3 col-3 mb-lg-3 text-center">
                                <div className="rounded-ball">
                                    <div className="counter">
                                        <span data-toggle="counter-up" className="timeLeft" id="days">{(timeLeft.days < 10) ? '0' + timeLeft.days : timeLeft.days}</span>
                                        &nbsp;
                                        <span className="textCounter d-none d-lg-inline text-center" id="daysCounter">Days</span>
                                        <p className="textCounter d-block d-lg-none text-center" id="daysCounter">Days</p>
                                    </div>
                                </div>
                                </div>
                    
                                <div className="col-lg-3 col-3 mb-lg-3 text-center">
                                <div className="rounded-ball">
                                    <div className="counter">
                                        <span data-toggle="counter-up" className="timeLeft" id="hours">{(timeLeft.hours < 10) ? '0' + timeLeft.hours : timeLeft.hours}</span>
                                        &nbsp;
                                        <span className="textCounter d-none d-lg-inline text-center" id="hoursCounter">Hours</span>
                                        <p className="textCounter d-block d-lg-none text-center" id="hoursCounter">Hours</p>
                                    </div>
                                </div>
                                </div>
                    
                                <div className="col-lg-3 col-3 mb-lg-3 text-center">
                                <div className="rounded-ball">
                                    <div className="counter">
                                        <span data-toggle="counter-up" className="timeLeft" id="minutes">{(timeLeft.minutes < 10) ? '0' + timeLeft.minutes : timeLeft.minutes}</span>
                                        &nbsp;
                                        <span className="textCounter d-none d-lg-inline text-center" id="minutesCounter">Minutes</span>
                                        <p className="textCounter d-block d-lg-none text-center" id="minutesCounter">Minutes</p>
                                    </div>
                                </div>
                                </div>
                    
                                <div className="col-lg-3 col-3 mb-lg-3 text-center">
                                <div className="rounded-ball">
                                    <div className="counter">
                                        <span data-toggle="counter-up" className="timeLeft" id="seconds">{(timeLeft.seconds < 10) ? '0' + timeLeft.seconds : timeLeft.seconds}</span>
                                        &nbsp;
                                        <span className="textCounter d-none d-lg-inline text-center" id="secondsCounter">Seconds</span>
                                        <p className="textCounter d-block d-lg-none text-center" id="secondsCounter">Seconds</p>
                                    </div>
                                </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    )
}